<div class="p-grid">
  <div class="p-col-12 p-g-nopad show-md labels-no-margin p-grid">
    <div class="p-col-12 p-md-5">
      <label class="form-control-label"
        >*{{ labels['OfferSignatur']['name'] }}</label
      >
    </div>
    <div class="p-col-12 p-md-5">
      <label
        class="form-control-label"
        [innerHTML]="labels['OfferSignatur']['personalNumber']"
      ></label>
    </div>
  </div>
  <div class="p-col-12 p-g-nopad" *ngFor="let object of dataSet; let i = index">
    <app-offer-signature-row
      [dataObjectFromParent]="object"
      [offerInfo]="offerInfo"
      [labels]="labels"
      (spliceObjectNotYetCreated)="spliceRow(null, i)"
      (deletedObject)="spliceRow($event)"
      (createdObject)="setRowId($event, i)"
    ></app-offer-signature-row>
  </div>
  <div class="p-col-12 align-right">
    <app-button (click)="addRow()" [type]="'add'"></app-button>
  </div>
</div>
